import {
  APP_MODULE_GROUP,
  APP_MODULE_GROUP_LABELS,
  APP_MODULE_LABELS,
  AppModuleGroup,
  type AppModuleCatalogItem,
  type AppModuleCode,
} from '@gb-ticket/shared-types';

export const APP_MODULE_GROUP_ORDER = Object.values(AppModuleGroup);

export function moduleLabel(code: AppModuleCode): string {
  return APP_MODULE_LABELS[code];
}

export function formatModuleLabels(codes: readonly AppModuleCode[]): string {
  const labels = codes.map((code) => `„${moduleLabel(code)}“`);
  if (labels.length <= 1) {
    return labels[0] ?? '';
  }
  if (labels.length === 2) {
    return `${labels[0]} und ${labels[1]}`;
  }
  return `${labels.slice(0, -1).join(', ')} und ${labels[labels.length - 1]}`;
}

export function filterModuleItems(
  items: AppModuleCatalogItem[],
  query: string,
): AppModuleCatalogItem[] {
  const needle = query.trim().toLowerCase();
  return items.filter((item) => {
    if (item.locked) {
      return false;
    }
    return !needle || moduleLabel(item.code).toLowerCase().includes(needle);
  });
}

export function groupModuleItems(
  items: AppModuleCatalogItem[],
): { group: AppModuleGroup; label: string; items: AppModuleCatalogItem[] }[] {
  return APP_MODULE_GROUP_ORDER.map((group) => ({
    group,
    label: APP_MODULE_GROUP_LABELS[group],
    items: items.filter((item) => APP_MODULE_GROUP[item.code] === group),
  })).filter((section) => section.items.length > 0);
}
